import { FilterValues } from '../components/TableFilter/TableFilter';

export const applyFilters = <T extends Record<string, any>>(
  data: T[],
  filters: FilterValues
): T[] => {
  return data.filter((item) => {
    return Object.entries(filters).every(([key, value]) => {
      // Skip empty filters
      if (value === null || value === undefined || value === '' || 
          (Array.isArray(value) && value.length === 0)) {
        return true;
      }

      const itemValue = item[key];

      // Handle different filter types
      if (typeof value === 'string') {
        // Text search - case insensitive
        return itemValue?.toString().toLowerCase().includes(value.toLowerCase());
      }

      if (typeof value === 'boolean') {
        // Boolean comparison
        return itemValue === value;
      }

      if (Array.isArray(value)) {
        // Multi-select or range filters
        if (value.length === 2 && typeof value[0] === 'number') {
          // Number range
          const numValue = Number(itemValue);
          const [min, max] = value;
          return (!min || numValue >= min) && (!max || numValue <= max);
        }
        
        if (value.length === 2 && value[0] instanceof Date) {
          // Date range
          const itemDate = new Date(itemValue);
          const [startDate, endDate] = value;
          return (!startDate || itemDate >= startDate) && (!endDate || itemDate <= endDate);
        }

        // Multi-select
        return value.includes(itemValue);
      }

      // Direct comparison
      return itemValue === value;
    });
  });
};
